<template>
    <b-card border-variant="dark" class="mt-4">
      <div class="height-queue">
        <span class="font-weight-bold font-15">Atendimento por Operador</span>
  
        <b-table id="queue" small striped bordered fixed :per-page="perPage" :fields="fields" :items="items"
          responsive="sm" class="mt-2" :current-page="currentPage" show-empty>
          <template #empty>
            <h6 class="text-center">Nenhum cliente na fila</h6>
          </template>
  
          <template #cell(status)="data">
            <b-badge :variant="getStatus(data.item.status).variant">
              {{ getStatus(data.item.status).txt }}
            </b-badge>
          </template>
        </b-table>
  
        <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" aria-controls="queue" size="sm"
          align="right"></b-pagination>
      </div>
    </b-card>
  </template>
  
  <script>
  const { connection } = require('./../../../modules/realtime/service/service');
  
  export default {
    name: "TbFilaAtendimentoOperador",
  
    data: () => ({
      fields: [
        { key: 'operator', label: 'Operador', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
        { key: 'atendimento', label: 'Quantidade', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
        { key: 'status', label: 'Status', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
  
      ],
      currentPage: 1,
      perPage: 10,
      queues: [],
      userChatQueues: [],
      users: [],
      attFilter: '*',
      items: [],
      operatorAvailable: {},
      operatorInAttendance: [],
    }),
  
    created() {
      axios.get('/user-chat-queues').then(({ data }) => {
        this.userChatQueues = data;
        this.userChatQueues.push('entrante');
      });
  
      axios.get('/realtime/listUsersChat', {}).then(({ data }) => {
        this.users = data;
      });
  
      connection.on('availableChat', (obj) => {
        this.operatorAvailable = obj;
        this.getItems();
      });
  
      connection.on('attendanceChat', (obj) => {
        this.operatorInAttendance = obj.atendimento;
        this.getItems();
      });
  
      connection.on('queueAttend', (obj) => {
        this.queues = obj.queues || [];
        this.getItems();
      });
    },
  
    computed: {
      rows() {
        return this.items.length;
      }
    },
  
    mounted() {
      this.getItems();
    },
  
    methods: {
      getStatus(stt) {
        if (stt === 'c_deslogado') return { txt: 'Deslogado', variant: 'danger' };
        if (stt === 'a_em_atendimento') return { txt: 'Em Atendimento', variant: 'warning' };
        if (stt === 'b_ativo') return { txt: 'Disponível', variant: 'primary' };
        return { txt: 'Desconhecido', variant: 'secondary' };
      },
  
      getItems() {
        this.items = this.mountTable();
      },
  
      mountTable() {
        const operatorClients = {};
  
        this.queues.forEach(q => {
        if (this.userChatQueues.includes(q.queue)) {
          const userOperator = this.users.find(o => o.id == q.operator);
          if (!userOperator) return; 

          const operatorName = userOperator.nome;

          const isOnline = this.operatorAvailable?.disponivel?.[q.operator];
          const isInAttendance = this.operatorInAttendance.some(op => op.operator === q.operator);

          let status = 'c_deslogado';
          if (isOnline && isInAttendance) status = 'a_em_atendimento';
          else if (isOnline) status = 'b_ativo';

          if (!operatorClients[operatorName]) {
            operatorClients[operatorName] = {
              atendimento: 0,
              status
            };
          }

          operatorClients[operatorName].atendimento += 1;
        }
      });
        return Object.keys(operatorClients).map(operator => ({
          operator,
          status: operatorClients[operator].status,
          atendimento: operatorClients[operator].atendimento
        }));
      }
    },
  
    watch: {
      async queues() {
        this.getItems();
      },
      attFilter() {
        this.getItems();
      }
    }
  }
  </script>
  
  <style scoped>
  .card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
  }
  
  .font-15 {
    font-size: 15px;
  }
  
  .height-queue {
    /* height: 205px; */
  }
  </style>
  